import { render, staticRenderFns } from "./payDialogDetail.vue?vue&type=template&id=2b98c64a&scoped=true"
import script from "./payDialogDetail.vue?vue&type=script&lang=js"
export * from "./payDialogDetail.vue?vue&type=script&lang=js"
import style0 from "./payDialogDetail.vue?vue&type=style&index=0&id=2b98c64a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b98c64a",
  null
  
)

export default component.exports